import { render, staticRenderFns } from "./ProfitLossTable.vue?vue&type=template&id=4d126fb8&scoped=true&"
import script from "./ProfitLossTable.vue?vue&type=script&lang=ts&"
export * from "./ProfitLossTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitLossTable.vue?vue&type=style&index=0&id=4d126fb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d126fb8",
  null
  
)

export default component.exports